/**
 * Extracts text from multilingual array or string
 * @param data - Can be a string, array of {text, language} objects, or already parsed array
 * @param preferredLanguage - Preferred language code (default: 'en')
 * @returns The text in the preferred language, or first available language, or the string itself
 */
export const extractTourText = (
  data: string | Array<{ text: string; language: string }> | any,
  preferredLanguage: string = 'en'
): string => {
  // If it's already a string, return it (backward compatibility)
  if (typeof data === 'string') {
    // Check if it's a JSON string
    try {
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed) && parsed.length > 0) {
        // Find preferred language or first available
        const preferred = parsed.find((item: any) => item.language === preferredLanguage);
        if (preferred && preferred.text) return preferred.text;
        return parsed[0]?.text || data;
      }
      return data;
    } catch {
      return data;
    }
  }

  // If it's an array
  if (Array.isArray(data) && data.length > 0) {
    // Find preferred language or first available
    const preferred = data.find((item: any) => item.language === preferredLanguage);
    if (preferred && preferred.text) return preferred.text;
    return data[0]?.text || '';
  }

  // Fallback
  return '';
};

